package io.horion.cv.models

data class Job(
    //@SerialName(value = "_id")
    val id: String = "",
    val enterprise: String = "",               // Nom de l’enterprise
    var title: String= "",                            // Titre du poste (ex: "Développeur Android")
    var city: String= "",                             // Lieu (ex: "Douala, Cameroun")
    val type: JobType = JobType.FREELANCE,                            // Type de contrat (CDI, Stage, etc.)
    var description: String= "",                      // Description complète
    val requirements: List<String> = emptyList(), // Compétences ou exigences requises
    val responsibilities: List<String> = emptyList(), // Responsabilités du poste
    val salaryRange: SalaryRange = SalaryRange(
        min = 0,
        max =0,
        currency = ""
    ),         // Salaire (optionnel)
    var experience: ExperienceLevel = ExperienceLevel.MID, // Niveau d’expérience
    val publicateAt: String= "",                  // Date de publication (ex: "2025-10-06")
    val expire: String = "",           // Date limite de candidature
    val contactEmail: String= "",                     // Email pour postuler
    val tags: List<String> = emptyList(),         // Tags pour filtrer (ex: ["Kotlin", "Backend"])
    var isRemote: Boolean = false,                // Télétravail possible ?
    val status: JobStatus = JobStatus.ACTIVE,      // Offre active ou expirée
    val createdAt: String = "",
    val updatedAt: String = ""
){

}
